export enum CertificateInformationEnum {
  JSE_CERTIFICATE = "JSE_CERTIFICATE",
  REVOKED_JSE_CERTIFICATE = "REVOKED_JSE_CERTIFICATE",
  VALID_US_CERTIFICATE = "VALID_US_CERTIFICATE",
  QCP_CERTIFICATE = "QCP_CERTIFICATE",
  PROGRESS_JSE_CERTIFICATE = "PROGRESS_JSE_CERTIFICATE",
}
